<template>
  <v-form>
    <div class="mb-4">
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-comprador
            dense
            required
            label="Local de faturamento"
            class="required rounded-tag-small"
            :error="$v.requisicao.comprador.$error"
            @blur="$v.requisicao.comprador.$touch()"
            v-model="requisicao.comprador"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-comprador
            dense
            required
            label="Local de entrega"
            class="required rounded-tag-small"
            :error="$v.requisicao.compradorEntrega.$error"
            @blur="$v.requisicao.compradorEntrega.$touch()"
            v-model="requisicao.compradorEntrega"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-select-enum dense
                          label="Urgência"
                          class="rounded-tag-small required"
                          v-model="requisicao.urgencia"
                          :error="$v.requisicao.urgencia.$error"
                          @blur="$v.requisicao.urgencia.$touch()"
                          :items="urgencias"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-date-picker dense
                          label="Data de Entrega"
                          input-class="rounded-tag-small required"
                          v-model="requisicao.dataEntrega"
                          :error="$v.requisicao.dataEntrega.$error"
                          @blur="$v.requisicao.dataEntrega.$touch()"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <px-autocomplete-projeto
            dense
            class="rounded-tag-small"
            v-model="requisicao.projeto"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-autocomplete-centro-custo
            dense
            :class="`rounded-tag-small ${isCentroCustoRequired ? 'required' : ''}`"
            :error="$v.requisicao.centroCusto.$error"
            @blur="$v.requisicao.centroCusto.$touch()"
            v-model="requisicao.centroCusto"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            label="Observações internas"
            counter="1500"
            rows="3"
            class="rounded-tag-small"
            v-model="requisicao.observacaoInterna"
          >
            <template v-slot:append-outer>
              <px-anexo v-model="requisicao.arquivos"
                        :max="3">
              </px-anexo>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            label="Observações externas"
            counter="1500"
            rows="3"
            class="rounded-tag-small"
            v-model="requisicao.observacaoExterna"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <div class="font-weight-bold body-2">
            Finalidade da compra
          </div>
          <v-radio-group
            row
            v-model="requisicao.finalidadeCompra"
            class="d-flex"
          >
            <v-radio
              v-for="finalidade in finalidades"
              :key="finalidade.key"
              :label="finalidade.description"
              :value="finalidade.key"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-btn class="rounded-tag-small normal-btn-text elevation-0"
                 color="primary"
                 @click="next">
            Continuar
          </v-btn>
          <v-btn class="normal-btn-text"
                 text
                 @click="onClickCancelar">
            Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { FinalidadeCompra, UrgenciaRequisicao } from 'px-business-components';
import { required, requiredIf } from 'vuelidate/lib/validators';
import {
  isFieldRequiredEntity,
} from '@/modules/erp-campos-obrigatorios/erp-campos-obrigatorios-utils';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
    camposObrigatorios: Object,
  },
  data() {
    return {
      finalidades: FinalidadeCompra.values,
      urgencias: UrgenciaRequisicao.values,
    };
  },
  computed: {
    isCentroCustoRequired() {
      return isFieldRequiredEntity('centroCusto', this.camposObrigatorios);
    },
  },
  methods: {
    next() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('next');
    },
    onClickCancelar() {
      this.$emit('cancel');
    },
  },
  validations: {
    requisicao: {
      comprador: {
        required,
      },
      compradorEntrega: {
        required,
      },
      urgencia: {
        required,
      },
      dataEntrega: {
        required,
      },
      centroCusto: {
        required: requiredIf(function () {
          return this.isCentroCustoRequired;
        }),
      },
    },
  },
};
</script>
